import { cx } from "@suse-o11y/class-variance";
import { useComputed } from "@suse-o11y/signal";
import React from "react";

import { ToggleListLocationContextProvider } from "./_toggle-list-location-context";
import { useToggleListNamespace } from "./_toggle-list-root-context";
import { useToggleListState } from "./_toggle-list-state-context";

export const ToggleListLocationTrigger: React.FC<React.PropsWithChildren> = ({ children }) => (
	<ToggleListLocationContextProvider value="trigger">{children}</ToggleListLocationContextProvider>
);

export const ToggleListLocationContent: React.FC<{
	className?: string;
	children?: React.ReactNode;
}> = ({ className, ...props }) => {
	const namespace = useToggleListNamespace();
	const state = useToggleListState();

	const isExpanded = useComputed((monitor) => state.isExpanded(monitor, namespace.read(monitor)));

	return (
		<ToggleListLocationContextProvider value="content">
			{isExpanded && (
				<div
					{...props}
					className={cx(
						"flex flex-col items-start gap-[5px] border-0 border-grey-400 border-l border-dashed",
						className,
					)}
				/>
			)}
		</ToggleListLocationContextProvider>
	);
};
